import o from"axios";const t=(t,p)=>o.post(t,p);export{t as sendBookingRequest};
//# sourceMappingURL=BookingRequest.api.js.map
